// src/components/ui/Avatar.jsx
import React from 'react';
import { Link } from 'react-router-dom';

const Avatar = ({ 
  user, 
  size = 'md', 
  withName = false, 
  linkToProfile = true,
  className = '',
  onClick = null
}) => {
  // Determine avatar URL - use default if none provided
  const avatarUrl = user?.avatar
    ? `${process.env.REACT_APP_ASSETS_URL}/uploads/profile/${user.avatar}`
    : `${process.env.REACT_APP_ASSETS_URL}/uploads/profile/default-avatar.png`;

  // Size classes mapping
  const sizeClasses = {
    xs: 'w-6 h-6',
    sm: 'w-8 h-8',
    md: 'w-10 h-10',
    lg: 'w-16 h-16',
    xl: 'w-24 h-24'
  };

  // Build avatar component
  const avatarContent = (
    <div 
      className={`flex items-center ${onClick ? 'cursor-pointer' : ''} ${className}`}
      onClick={onClick}
    >
      <div className={`${sizeClasses[size]} rounded-full overflow-hidden bg-gray-200 flex-shrink-0`}>
        <img 
          src={avatarUrl} 
          alt={user?.name || 'User'} 
          className="w-full h-full object-cover"
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = `${process.env.REACT_APP_ASSETS_URL}/uploads/profile/default-avatar.png`;
          }}
        />
      </div>
      
      {withName && user?.name && (
        <div className="ml-2 flex items-center">
          <span className="font-medium text-gray-900">{user.name}</span>
          {user?.isVerified && (
            <span className="ml-1 flex items-center justify-center w-4 h-4 bg-blue-500 text-white rounded-full text-xs">
              ✓
            </span>
          )}
        </div>
      )}
    </div>
  );

  // Wrap in link if linkToProfile is true and we have a user ID
  if (linkToProfile && user?._id) {
    return (
      <Link to={`/profile/${user._id}`} className="inline-flex">
        {avatarContent}
      </Link>
    );
  }

  return avatarContent;
};

export default Avatar;